import React, { useEffect } from "react";
import GModal from "components/ui/modal/Modal";
import { useTranslation } from "react-i18next";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import GButton from "components/ui/button/Button";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { giftCardDropList, addgiftCard, giftCardList,} from "../../services/giftCardService";
import { useParams } from "react-router-dom";

const AddSubGroupModal = ({ onClose }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const id = useParams();
  const toast = useToast({position: "top", duration: 3000, status: "success",});
  const toast2 = useToast({position: "top", duration: 3000, status: "error",});
  const { handleSubmit, setValue } = useForm();

  const allProducts = useSelector((state) => state.giftsCard);

  useEffect(() => {
    dispatch(giftCardDropList());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.groups.add_giftcard")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              values.MenuGroup = values.MenuGroup?.map((el) => ({
                GiftCardsId: el.GiftCardsId,
                MenuGroupId: id.groupId,
              }));
              if (
                values.MenuGroup === undefined ||
                values.MenuGroup.length === 0
              ) {
                toast2({
                  description: t("pages.DailyRestrictions.searchvalidation"),
                });
              } else {
                dispatch(addgiftCard(values))
                  .unwrap()
                  .then((_) => {
                    toast({ description: t("pages.groups.giftcard_added") });
                    dispatch(giftCardList(id.groupId));
                    onClose();
                  });
              }
            })}
          >
            <Stack>
              <MultiSelect
                title={t("pages.groups.giftcard")}
                data={
                  Array.isArray(allProducts.giftCardData1)
                    ? allProducts.giftCardData1.map((el) => ({
                        ...el,
                        label: el.GiftCardsName,
                        value: el.GiftCardsId,
                      }))
                    : []
                }
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("MenuGroup", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  isLoading={allProducts.isLoading}
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  isLoading={allProducts.isLoading}
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddSubGroupModal;
